module.exports = __webpack_public_path__ + "img/186-Gris Basalte.jpg";